import { render, staticRenderFns } from "./LmEChartBarsBuilder.vue?vue&type=template&id=45b3848c&"
import script from "./LmEChartBarsBuilder.vue?vue&type=script&lang=js&"
export * from "./LmEChartBarsBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports